/* CherieVerse Shopify theme: restrained motion for menu, postcard flip and back-to-top. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cv-top]').forEach((button) => {
    button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  });

  document.querySelectorAll('[data-cv-flip]').forEach((control) => {
    const card = control.closest('.cv-postcard-stage')?.querySelector('.cv-postcard-card');
    if (!card) return;
    control.addEventListener('click', () => {
      const flipped = card.classList.toggle('is-flipped');
      control.setAttribute('aria-pressed', String(flipped));
      control.querySelector('[data-cv-flip-label]').textContent = flipped ? '翻至正面' : '翻至背面';
    });
  });
});
